import { TFunction } from 'i18next';

export const getBackButtonLabel = (t: TFunction) =>
  t('general.back-button', 'Back');
